import React from "react";
import { Box, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const DraftPrePopup = ({ draftData, setDeleteActivity, setDeleteData }) => {
  const handleDelete = () => {
    setDeleteActivity(true);
    setDeleteData(draftData);
  };

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 3,
        minWidth: 180,
      }}
    >
      <Button
        variant="outlined"
        color="error"
        startIcon={<DeleteIcon />}
        fullWidth
        sx={{ textTransform: "none", whiteSpace: "nowrap" }}
        onClick={handleDelete}
      >
        Delete
      </Button>
    </Box>
  );
};

export default DraftPrePopup;
